import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { OutBoxStatus } from '../api/models';

@Directive({
  selector: '[outBoxStatusStyle]',
  standalone: true,
})
export class OutBoxStatusDirective implements OnInit {
  @Input('outBoxStatusStyle') status: OutBoxStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = '';

    switch (this.status) {
      //waiting
      case OutBoxStatus.WatingForSend:
      case OutBoxStatus.WatingForConfirm:
      case OutBoxStatus.IsBeingSent:
        classList = 'text-warning tw-font-medium';
        break;
      //error
      case OutBoxStatus.ErrorInSending:
      case OutBoxStatus.ErrorInGetItc:
        classList = 'text-danger tw-font-medium';
        break;
      //success
      case OutBoxStatus.Sent:
        classList = 'text-success tw-font-medium';
        break;
      default:
        break;
    }

    return classList;
  }
}
